import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-view-select-mindmap",
  "use": "icon-view-select-mindmap-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-view-select-mindmap\">\n<rect x=\"4\" y=\"7\" width=\"6\" height=\"4\" rx=\"1\" stroke=\"currentColor\" stroke-width=\"2\" />\n<rect x=\"13\" y=\"13\" width=\"6\" height=\"4\" rx=\"1\" stroke=\"currentColor\" stroke-width=\"2\" />\n<path d=\"M8 10V13C8 14.1046 8.89543 15 10 15L13 15\" stroke=\"currentColor\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol